import { useRouterState } from '@tanstack/react-router'
import { useMemo } from 'react'

// Mapeamento de rotas para títulos
const routeTitleMap: Record<string, string> = {
  '/': 'Login',
  '/workspace': 'Workspace',
  '/abrir-conta': 'Abrir Conta',
  '/recuperar-senha': 'Recuperar Senha',
  '/dashboard': 'Dashboard',
}

// Função para obter o título baseado no pathname
function getTitleFromPathname(pathname: string): string {
  // Remove barra final se existir
  const cleanPath = pathname.replace(/\/$/, '')

  // Verifica mapeamento exato primeiro
  if (routeTitleMap[cleanPath]) {
    return routeTitleMap[cleanPath]
  }

  // Padrões de rotas do dashboard
  const dashboardPatterns = [
    {
      pattern: /^\/dashboard\/\d+\/conversas\/[\w-]+\/[\w-]+$/,
      title: 'Conversa',
    },
    {
      pattern: /^\/dashboard\/\d+\/conversas\/[\w-]+$/,
      title: 'Canal',
    },
    {
      pattern: /^\/dashboard\/\d+\/conversas$/,
      title: 'Conversas',
    },
    {
      pattern: /^\/dashboard\/\d+\/oportunidades\/[\w-]+\/[\w-]+$/,
      title: 'Negócio',
    },
    {
      pattern: /^\/dashboard\/\d+\/oportunidades\/[\w-]+$/,
      title: 'Negócios',
    },
    {
      pattern: /^\/dashboard\/\d+\/oportunidades$/,
      title: 'Negócios',
    },
    {
      pattern: /^\/dashboard\/\d+\/atividades\/[\w-]+$/,
      title: 'Atividade',
    },
    {
      pattern: /^\/dashboard\/\d+\/atividades$/,
      title: 'Atividades',
    },
    {
      pattern: /^\/dashboard\/\d+\/contatos\/[\w-]+$/,
      title: 'Contato',
    },
    {
      pattern: /^\/dashboard\/\d+\/contatos$/,
      title: 'Contatos',
    },
    {
      pattern: /^\/dashboard\/\d+\/imoveis\/[\w-]+$/,
      title: 'Imóvel',
    },
    {
      pattern: /^\/dashboard\/\d+\/imoveis$/,
      title: 'Imóveis',
    },
    {
      pattern: /^\/dashboard\/\d+\/empreendimentos\/[\w-]+\/editar$/,
      title: 'Editar Empreendimento',
    },
    {
      pattern: /^\/dashboard\/\d+\/empreendimentos\/[\w-]+$/,
      title: 'Empreendimento',
    },
    {
      pattern: /^\/dashboard\/\d+\/empreendimentos$/,
      title: 'Empreendimentos',
    },
    {
      pattern: /^\/dashboard\/\d+\/chaves\/[\w-]+$/,
      title: 'Registro de Chave',
    },
    {
      pattern: /^\/dashboard\/\d+\/chaves$/,
      title: 'Controle de Chaves',
    },
    {
      pattern: /^\/dashboard\/\d+\/portais\/[\w-]+$/,
      title: 'Portal',
    },
    {
      pattern: /^\/dashboard\/\d+\/portais$/,
      title: 'Portais',
    },
    {
      pattern: /^\/dashboard\/\d+\/catalogo$/,
      title: 'Catálogo',
    },
    {
      pattern: /^\/dashboard\/\d+\/financeiro\/lancamentos$/,
      title: 'Lançamentos',
    },
    {
      pattern: /^\/dashboard\/\d+\/financeiro$/,
      title: 'Financeiro',
    },
    {
      pattern: /^\/dashboard\/\d+\/marketing$/,
      title: 'Marketing',
    },
    {
      pattern: /^\/dashboard\/\d+\/documentos-digitais\/modelos\/novo$/,
      title: 'Novo modelo de documento',
    },
    {
      pattern: /^\/dashboard\/\d+\/documentos-digitais\/modelos\/[\w-]+$/,
      title: 'Editar modelo de documento',
    },
    {
      pattern: /^\/dashboard\/\d+\/documentos-digitais\/modelos$/,
      title: 'Modelos de documentos',
    },
    {
      pattern: /^\/dashboard\/\d+\/documentos-digitais\/gerados\/novo$/,
      title: 'Gerar documento',
    },
    {
      pattern: /^\/dashboard\/\d+\/documentos-digitais\/gerados\/[\w-]+\/editar$/,
      title: 'Editar documento',
    },
    {
      pattern: /^\/dashboard\/\d+\/documentos-digitais\/gerados\/[\w-]+$/,
      title: 'Documento gerado',
    },
    {
      pattern: /^\/dashboard\/\d+\/documentos-digitais\/assinaturas$/,
      title: 'Assinaturas digitais',
    },
    {
      pattern: /^\/dashboard\/\d+\/documentos-digitais\/gerados$/,
      title: 'Documentos gerados',
    },
    {
      pattern: /^\/dashboard\/\d+\/relatorios\/oportunidades$/,
      title: 'Relatório de Negócios',
    },
    {
      pattern: /^\/dashboard\/\d+\/relatorios\/imoveis$/,
      title: 'Relatório de Imóveis',
    },
    {
      pattern: /^\/dashboard\/\d+\/relatorios\/leads$/,
      title: 'Relatório de Leads',
    },
    {
      pattern: /^\/dashboard\/\d+\/relatorio$/,
      title: 'Relatórios',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema\/usuarios$/,
      title: 'Usuários',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema\/funis$/,
      title: 'Funis',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema\/whatsapp$/,
      title: 'WhatsApp',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema\/meta-leads$/,
      title: 'Meta Leads',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema\/conversas$/,
      title: 'Configurações de Conversas',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema\/distribuicao-inteligente$/,
      title: 'Distribuição Inteligente',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema\/plano-faturas$/,
      title: 'Plano & Faturas',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema\/financeiro$/,
      title: 'Configurações Financeiras',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema\/logs$/,
      title: 'Logs',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema\/motivos-perdas$/,
      title: 'Motivos de Perdas',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema\/campos-customizados$/,
      title: 'Campos Customizados',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema\/comodidades$/,
      title: 'Comodidades',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema\/segmentos$/,
      title: 'Segmentos',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema\/dados$/,
      title: 'Dados',
    },
    {
      pattern: /^\/dashboard\/\d+\/sistema$/,
      title: 'Sistema',
    },
    {
      pattern: /^\/dashboard\/\d+\/suporte$/,
      title: 'Suporte',
    },
    {
      pattern: /^\/dashboard\/\d+\/sites\/[\w-]+\/blog\/[\w-]+$/,
      title: 'Artigo',
    },
    {
      pattern: /^\/dashboard\/\d+\/sites\/[\w-]+\/blog\/novo$/,
      title: 'Novo Artigo',
    },
    {
      pattern: /^\/dashboard\/\d+\/sites\/[\w-]+\/blog$/,
      title: 'Blog',
    },
    {
      pattern: /^\/dashboard\/\d+\/sites\/[\w-]+$/,
      title: 'Site',
    },
    {
      pattern: /^\/dashboard\/\d+\/incorporadoras\/[\w-]+\/editar$/,
      title: 'Editar Incorporadora',
    },
    {
      pattern: /^\/dashboard\/\d+\/incorporadoras\/[\w-]+$/,
      title: 'Incorporadora',
    },
    {
      pattern: /^\/dashboard\/\d+\/incorporadoras$/,
      title: 'Incorporadoras',
    },
    {
      pattern: /^\/dashboard\/\d+$/,
      title: 'Dashboard',
    },
  ]

  // Verifica padrões de rotas do dashboard
  for (const { pattern, title } of dashboardPatterns) {
    if (pattern.test(cleanPath)) {
      return title + ' | ImobDesk'
    }
  }

  // Título padrão
  return 'ImobDesk'
}

export function usePageTitle() {
  const router = useRouterState()
  const pathname = router.location.pathname

  const title = useMemo(() => {
    return getTitleFromPathname(pathname)
  }, [pathname])

  return title
}
